//Formula docs: https://coda.io/d/Cypro_dMvC8MjNjA7/GFR_suagDNUm#_lu09JQsR
export function cockcroftGault(age, weightKg, serumCreatinineMgDl, isFemale = false) {
    const result = ((140 - age) * weightKg) / (72 * serumCreatinineMgDl);
    return isFemale ? result * 0.85 : result;
}
export function jelliffe(age, bsaM2, serumCreatinineMgDl, isFemale = false) {
    const bsaFactor = bsaM2 / 1.73;
    const result = ((98 - 0.8 * (age - 20)) * bsaFactor) / serumCreatinineMgDl;
    return isFemale ? result * 0.9 : result;
}
export function mgDlToUmolL(mgDl) {
    return mgDl * 88.4;
}
export function umolLToMgDl(umolL) {
    return umolL / 88.4;
}
export const urinary24h = (urineCreatinine, urineVolumeMl, serumCreatinineMgDl, collectingTime) => {
    return (urineVolumeMl * urineCreatinine) / (serumCreatinineMgDl * collectingTime);
};
/**
 * A GFR above this many mL/min is not physiologically plausible and comes from a wrong input (e.g. a creatinine
 * typed in the wrong unit). It is never saved, since the saved GFR becomes the one AUC (carboplatin) doses use (CY-348).
 */
export const GFR_PLAUSIBLE_MAX = 200;
export function isGfrPlausible(gfr) {
    return Number.isFinite(gfr) && gfr > 0 && gfr <= GFR_PLAUSIBLE_MAX;
}
//# sourceMappingURL=gfr.js.map